import { ModusWcDivider } from '@trimble-oss/moduswebcomponents-react';

import './Divider.scss';

type DividerProps = React.ComponentProps<typeof ModusWcDivider>;
export const Divider: React.FC<DividerProps> = (props) => {
  return <ModusWcDivider {...props} />;
};

export default Divider;
